import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

import { SplashService } from '@polk_county_public_schools/ngx-pcps-dialogs';

@Injectable({
    providedIn: 'root',
})
export class ErrorService {
    constructor(private splashSvc: SplashService) {}

    // #region Handle Service Error Service Call

    // tslint:disable-next-line: no-any
    HandleServiceError(error: any): void {
        const self = this;

        let status: number | null = null;
        let msg = '';
        if (error instanceof HttpErrorResponse) {
            status = error.status;

            let body = error?.error ?? error;

            if (!!body?.errors && typeof body.errors === 'object') {
                // tslint:disable-next-line: no-any
                const errobj = body.errors as any;
                const errkeys = Object.keys(errobj);

                msg = errkeys
                    .map((k) => {
                        return errobj[k].toString();
                    })
                    .join('|');
            } else if (!!body?.error) {
                body = body.error;

                msg = body.ExceptionMessage || body.Message || body.message || body || 'An unknown error has occurred.';
            } else {
                msg = body.ExceptionMessage || body.Message || body.message || body || 'An unknown error has occurred.';
            }
        } else {
            if (!!error?.errors && typeof error.errors === 'object') {
                const errkeys = Object.keys(error.errors);

                msg = errkeys
                    .map((k) => {
                        return error.errors[k].toString();
                    })
                    .join('|');
            } else {
                let errorPacket = error?.message ?? error;
                if (typeof errorPacket !== 'object' && errorPacket != null && errorPacket !== '') {
                    try {
                        errorPacket = JSON.parse(errorPacket);
                    } catch {
                        errorPacket = errorPacket || 'An unknown error has occurred.';
                    }
                }
                msg =
                    errorPacket != null && errorPacket instanceof Object
                        ? errorPacket.ExceptionMessage || errorPacket.Message || error
                        : errorPacket || 'An unknown error has occurred.';
            }
        }

        // Something else, which should be snackbar displayed.
        if (msg.length > 300) {
            msg = msg.substr(0, 300) + '...';
        }

        // this.splashSvc.CloseSplash();
        this.splashSvc.SnackbarError(msg, 5 * 1000);
    }

    // #endregion

    // #region Retrieve Service Error Service Call

    // tslint:disable-next-line: no-any
    RetrieveServiceError(error: any): ErrorInfo | null {
        let status: number | null = null;
        let msg: string = '';

        // Get the error message from the object, if we can.
        msg = this.RetrieveServiceErrorMessage(error);

        status = error instanceof HttpErrorResponse ? (error.status === 0 ? 500 : error.status) : 500;

        return {
            ErrorMessage: msg,
            ErrorObject: error,
            Status: status,
            IsRecoverable:
                [401, 500].includes(status) &&
                [
                    'Session has expired.',
                    'No user information found.',
                    `User's current session has expired`,
                    `You appear to be disconnected. Please verify your network connection.`,
                ].includes(msg),
        } as ErrorInfo;
    }

    // #endregion

    // #region Retrieve Service Error Message Service Call

    // tslint:disable-next-line: no-any
    RetrieveServiceErrorMessage(error: any): string {
        let body = error && error.error;
        let msg = '';

        if (body instanceof Blob) {
            msg = 'An unknown error has occurred.';
        } else {
            if (body && body.errors && typeof body.errors === 'object') {
                // tslint:disable-next-line: no-any
                const errobj = body.errors as any;
                const errkeys = Object.keys(errobj);

                msg = errkeys
                    .map((k) => {
                        return errobj[k].toString();
                    })
                    .join('|');
            } else if (body && body.error) {
                body = body.error;

                msg = body.ExceptionMessage || body.Message || body.message || body || 'An unknown error has occurred.';
            } else if (body && body.InnerException) {
                body = body.InnerException;

                msg = body.ExceptionMessage || body.Message || body.message || body || 'An unknown error has occurred.';
            } else if (body instanceof ProgressEvent) {
                msg = (error as HttpErrorResponse).statusText || 'An unknown error has occurred.';
                if (msg === 'Unknown Error') {
                    msg = 'You appear to be disconnected. Please verify your network connection.';
                }
            } else {
                msg = body.ExceptionMessage || body.Message || body.message || body || 'An unknown error has occurred.';
            }
        }

        if (msg && msg.includes && msg.includes('Session has expired.')) {
            msg = 'Session has expired.';
        }

        return msg;
    }

    // #endregion
}

// #region Custom Classes

export interface ErrorInfo {
    ErrorObject: any;
    ErrorMessage: string;
    IsRecoverable: boolean;
    Status: number;
}

// #endregion
